import React from "react";
import AgentForgotPassword from "../../organisms/AgentInitialPagesComponents/AgentForgotPassword/AgentForgotPassword";

const AgentForgotPasswordPage = () => {
  return <AgentForgotPassword />;
};

export default AgentForgotPasswordPage;
